
import {Vue, Component, PropSync} from 'vue-property-decorator';
import {BackEndService} from 'src/utils/BackEndService';
import TeacherIcon from 'src/modules/teacher/TeacherIcon.vue';
import { getAssetItem } from 'src/utils/helpers';

@Component({
  components: {TeacherIcon},
  methods: {getAssetItem}
})
export default class WaitingSubscriptionModal extends Vue {
  @PropSync('isWaitingSubscriptionModalDisplayed') isDisplayed: boolean;
  paymentSucceeded: boolean = false;
  trialEnabled: boolean = false;
  trialEndDate: string = '';

  mounted() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }

  handleVisibilityChange() {
    if (!document.hidden) {
      BackEndService.sendGetRequest('user').then((response) => {
        if (response.data.status === 'PAID_MEMBER') {
          this.paymentSucceeded = true;
        } else if (response.data.status === 'TRIAL' && response.data.is_in_payment_group_a_or_b) {
          this.trialEnabled = true;
          this.trialEndDate = Intl.DateTimeFormat('fr-FR', {month: 'long', day: 'numeric'}).format(
            new Date(response.data.trial_ends_at)
          );
        }
      });
    }
  }

  closeModal() {
    this.isDisplayed = false;
    if (this.paymentSucceeded || this.trialEnabled) {
      this.$root.$emit('paymentSucceeded');
    }
  }
}
